/* src/app/forms/painel-correios/cep-range/cep-range.component.scss */
.card-model {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.mat-mdc-card-title {
  font-size: 180%;
}
.card-content {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
:host {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.title-card {
  width: 100%;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
}
.data-content {
  height: 100%;
  width: 100%;
  display: grid;
}
/*# sourceMappingURL=cep-range.component.css.map */
